import React from 'react';
import { AnimateOnScroll } from './AnimateOnScroll';
export function BeliefSection() {
  return <section className="bg-[#E91E8C] py-16 lg:py-24 relative overflow-hidden pb-[0px]" data-id="element-25">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-26">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 lg:gap-16" data-id="element-27">
          {/* Left Column - Text Content (55%) */}
          <AnimateOnScroll className="w-full lg:w-[55%] text-white" data-id="element-28">
            {/* Main Headline */}
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-[52px] uppercase text-white leading-[1.05] mb-6 font-[700] font-[Poppins,_sans-serif] italic" data-id="element-29">
              WE BELIEVE THAT LOOKING GOOD IS THE FIRST STEP TOWARDS FEELING
              GOOD
            </h2>

            {/* Italic Annotation */}
            <p className="font-serif italic text-lg text-white/90 mb-8" data-id="element-30">
              (which fosters)
            </p>

            {/* Body Content with Bullet */}
            <div className="space-y-6" data-id="element-31">
              <div className="flex items-start gap-4" data-id="element-32">
                <img src="https://cdn.magicpatterns.com/uploads/qiTwBpHJoCvs5SobAByGyk/Vector_12_(1).png" alt="" className="w-3 h-3 mt-2 flex-shrink-0" data-id="element-33" />
                <p className="text-base lg:text-lg text-white/95 leading-relaxed font-[Poppins,_sans-serif]" data-id="element-34">
                  We believe that looking good is the first step towards feeling
                  good, which fosters happiness.
                </p>
              </div>

              <p className="text-base lg:text-lg text-white/95 leading-relaxed font-[Poppins,_sans-serif] pl-7" data-id="element-35">
                Happier individuals spread positivity to everyone around
                them—from family to strangers.
              </p>

              <p className="text-base lg:text-lg text-white/95 leading-relaxed font-[Poppins,_sans-serif] pl-7" data-id="element-36">
                This uplift in spirit{' '}
                <strong className="text-white font-bold" data-id="element-37">
                  enhances confidence, helping people realize their true
                  potential.
                </strong>{' '}
                That's the profound impact of our work; it's not just about
                enhancing appearances, it's about empowering lives.
              </p>
            </div>
          </AnimateOnScroll>

          {/* Right Column - Doctor Image (45%) */}
          <AnimateOnScroll className="w-full lg:w-[45%] relative" delay={200} data-id="element-38">
            <div className="relative flex justify-center lg:justify-end" data-id="element-39">
              {/* Doctor Image */}
              <img src="https://cdn.magicpatterns.com/uploads/fDEhsEc7YJpKVAYRkyFKV8/ChatGPT_Image_Feb_13,_2026,_12_14_45_PM_2.png" alt="Dr. Fiona Frie, MD - Medical Director at Be CLINICAL" className="w-full max-w-md lg:max-w-none h-auto object-contain" data-id="element-40" />

              {/* Floating Badge */}
              <div className="absolute bottom-8 right-4 lg:bottom-16 lg:right-8 bg-white rounded-lg shadow-xl px-4 py-3 flex items-center gap-3" data-id="element-41">
                <div className="w-2.5 h-2.5 bg-[#E91E8C] rounded-full" data-id="element-42"></div>
                <div data-id="element-43">
                  <p className="font-bold text-sm text-gray-900 font-[Poppins,_sans-serif]" data-id="element-44">
                    Fiona Frie, MD
                  </p>
                  <p className="text-xs text-[#E91E8C] font-[Poppins,_sans-serif]" data-id="element-45">
                    medical director
                  </p>
                </div>
              </div>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}